import {
    FM_LOADING,
    FM_SELECT_FOLDER,
    FM_SELECT_FILE,
    FM_SEARCH_BY_JOB,

    FM_GET_FOLDERS,
    FM_CREATE_FOLDER,
    FM_UPDATE_FOLDER_BY_ID,
    FM_DELETE_FOLDER_BY_ID,
    FM_GET_FILES_BY_FOLDER_ID,
    FM_CREATE_FILES_BY_FOLDER_ID,
    FM_UPDATE_FILE_BY_FILE_ID,
    FM_DELETE_FILE_BY_FILE_ID,

    UME_GET_FOLDERS,
    UME_CREATE_FOLDER,
    UME_UPDATE_FOLDER_BY_ID,
    UME_DELETE_FOLDER_BY_ID,
    UME_GET_FILES_BY_FOLDER_ID,
    UME_CREATE_FILES_BY_FOLDER_ID,
    UME_UPDATE_FILE_BY_FILE_ID,
    UME_DELETE_FILE_BY_FILE_ID,
    UME_GET_FOLDER_PERMISSIONS,
    UME_CREATE_FOLDER_PERMISSIONS,
    UME_DELETE_FOLDER_PERMISSIONS,
    UME_DELETE_FOLDER_PERMISSIONS_BY_ID
} from "api/menu/file-manager/actions";

const initialState = {
    loading: false,

    selectedFolder: false,
    selectedFile: false,

    jobFilter: "",
    folders: [],
    files: [],

    umeFolders: [],
    umeFiles: [],
    umeFolderPermissions: []
};

export default function(state = initialState, action) {
    let folders,
        files,
        umeFolders,
        umeFiles,
        umeFolderPermissions,
        index;
    switch (action.type) {
        case FM_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case FM_SELECT_FOLDER:
            return {
                ...state,
                selectedFolder: action.payload
            };
        case FM_SELECT_FILE:
            return {
                ...state,
                selectedFile: action.payload
            };
        case FM_SEARCH_BY_JOB:
            return {
                ...state,
                jobFilter: action.payload
            };

        case FM_GET_FOLDERS:
            return {
                ...state,
                loading: false,
                folders: action.payload,
            };
        case FM_GET_FILES_BY_FOLDER_ID:
            return {
                ...state,
                loading: false,
                files: action.payload,
            };
        case FM_DELETE_FILE_BY_FILE_ID:
            return {
                ...state,
                loading: false,
                selectedFile: false
            };
        case FM_CREATE_FILES_BY_FOLDER_ID:
            files = Object.assign([], state.files);
            files.push(action.payload);
            return {
                ...state,
                loading: false,
                files
            };
        case FM_UPDATE_FILE_BY_FILE_ID:
            files = Object.assign([], state.files);
            index = files.findIndex(item =>
                parseInt(item.fileId, 10) === parseInt(action.payload.fileId, 10));
            if (index > -1) {
                files[index] = action.payload;
            }
            return {
                ...state,
                loading: false,
                files
            };
        case FM_CREATE_FOLDER:
            folders = Object.assign([], state.folders);
            folders.push(action.payload);
            return {
                ...state,
                loading: false,
                folders
            };
        case FM_UPDATE_FOLDER_BY_ID:
            folders = Object.assign([], state.folders);
            index = folders.findIndex(item =>
                parseInt(item.folderId, 10) === parseInt(action.payload.folderId, 10));
            if (index > -1) {
                folders[index] = action.payload;
            }
            return {
                ...state,
                loading: false,
                folders
            };
        case FM_DELETE_FOLDER_BY_ID:
            folders = Object.assign([], state.folders);
            index = folders.findIndex(item =>
                parseInt(item.folderId, 10) === parseInt(action.payload, 10));
            if (index > -1) {
                folders.splice(index, 1);
            }
            return {
                ...state,
                loading: false,
                selectedFolder: false,
                selectedFile: false,
                folders,
                files: []
            };

        case UME_GET_FOLDERS:
            return {
                ...state,
                loading: false,
                umeFolders: action.payload,
            };
        case UME_GET_FILES_BY_FOLDER_ID:
            return {
                ...state,
                loading: false,
                umeFiles: action.payload,
            };
        case UME_DELETE_FILE_BY_FILE_ID:
            return {
                ...state,
                loading: false,
                selectedFile: false
            };
        case UME_CREATE_FILES_BY_FOLDER_ID:
            umeFiles = Object.assign([], state.umeFiles);
            umeFiles.push(action.payload);
            return {
                ...state,
                loading: false,
                umeFiles
            };
        case UME_UPDATE_FILE_BY_FILE_ID:
            umeFiles = Object.assign([], state.umeFiles);
            index = umeFiles.findIndex(item =>
                parseInt(item.fileId, 10) === parseInt(action.payload.fileId, 10));
            if (index > -1) {
                umeFiles[index] = action.payload;
            }
            return {
                ...state,
                loading: false,
                umeFiles
            };
        case UME_CREATE_FOLDER:
            umeFolders = Object.assign([], state.umeFolders);
            umeFolders.push(action.payload);
            return {
                ...state,
                loading: false,
                umeFolders
            };
        case UME_UPDATE_FOLDER_BY_ID:
            umeFolders = Object.assign([], state.umeFolders);
            index = umeFolders.findIndex(item =>
                parseInt(item.folderId, 10) === parseInt(action.payload.folderId, 10));
            if (index > -1) {
                umeFolders[index] = action.payload;
            }
            return {
                ...state,
                loading: false,
                umeFolders
            };
        case UME_DELETE_FOLDER_BY_ID:
            umeFolders = Object.assign([], state.umeFolders);
            index = umeFolders.findIndex(item =>
                parseInt(item.folderId, 10) === parseInt(action.payload, 10));
            if (index > -1) {
                umeFolders.splice(index, 1);
            }
            return {
                ...state,
                loading: false,
                selectedFolder: false,
                selectedFile: false,
                umeFolders,
                umeFiles: []
            };
        case UME_GET_FOLDER_PERMISSIONS:
            return {
                ...state,
                loading: false,
                umeFolderPermissions: action.payload
            };
        case UME_CREATE_FOLDER_PERMISSIONS:
            umeFolderPermissions = Object.assign([], state.umeFolderPermissions);
            umeFolderPermissions.push(action.payload);
            return {
                ...state,
                loading: false,
                umeFolderPermissions
            };
        case UME_DELETE_FOLDER_PERMISSIONS:
            return {
                ...state,
                loading: false,
                umeFolderPermissions: []
            };
        case UME_DELETE_FOLDER_PERMISSIONS_BY_ID:
            umeFolderPermissions = Object.assign([], state.umeFolderPermissions);
            index = umeFolderPermissions.findIndex(item => item.id === action.payload);
            if (index > -1) {
                umeFolderPermissions.splice(index, 1);
            }
            return {
                ...state,
                loading: false,
                umeFolderPermissions
            };
        default:
            return state;
    }
}
